<template>
  <div>
    <span
      @click="onClickWrapper"
      class="checkbox-wrapper"
    >
      <input
        type="checkbox"
        ref="input"
        :value="agreedTerms"
        @change="onChange"
      />
      <span class="checkbox"></span>
      <span v-if="readTerms">個人情報の取扱について同意する</span>
      <span v-else>個人情報の取扱について確認する</span>
    </span>
    <proa-modal
      :modal="confirmeTermsModal"
      title="個人情報の取扱について"
      fluid
      @close="toggleConfirmTermsModal(false, true)"
    >
      <div class="d-flex flex-column h-100">
        <div class="font-weight-w6 text-left">{{ $t('common.modals.confirmTermsModal.caption') }}</div>
        <div class="terms-flex-wrapper">
          <div
            class="contents-wrapper"
            ref="termsContentsWrapper"
            @scroll="onScrollTermsWrapper"
          >
            <div ref="termsContens">
              <h5>[１] 事業者について</h5>
              <div>岩崎通信機株式会社<br>東京都杉並区久我山1丁目7番41号<br>代表取締役社長 木村彰吾</div>
              <h5 class="mt-4">[２] 個人情報保護管理者</h5>
              <div>岩崎通信機株式会社 取締役執行役員 コーポレート・マネジメント本部長</div>
              <h5 class="mt-4">[３] 個人情報の利用目的</h5>
              <div>ご入力いただいた個人情報は、当社へのお問い合わせ対応や履歴管理、当社が主催、協賛するセミナー、展示会等の運営・ご案内のために利用いたします。</div>
              <h5 class="mt-4">[４] 個人情報の第三者提供</h5>
              <div>以下の場合を除き、ご入力いただいた個人情報を第三者に提供することはありません。</div>
              <div>・本人の同意がある場合 ・法令に基づく場合</div>
              <div>・人の生命、身体又は財産の保護のために必要で、本人の同意を得ることが困難であるとき</div>
              <div>・公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合で、本人の同意を得ることが困難であるとき</div>
              <div>・国の機関もしくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行する上で必要がある場合で、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</div>
              <h5 class="mt-4">[５] 個人情報の共同利用について</h5>
              <div>当社はご入力いただいた個人情報を、上記[３]の利用目的達成のため、以下の条件で共同利用する場合があります。</div>
              <div>【共同利用する企業の範囲】</div>
              <div>岩崎通信機株式会社及び岩崎通信機株式会社の以下の関係会社</div>
              <div>・岩通ケミカルクロス株式会社</div>
              <div>・岩通ソフトシステム株式会社</div>
              <div>・電通サービス株式会社</div>
              <div>・東通工業株式会社</div>
              <div>【共同利用する個人情報の項目】</div>
              <div>お名前、お名前（フリガナ）、メールアドレス、会社・組織名、部署、役職、電話番号、所在地</div>
              <div>【共同利用についての責任者】</div>
              <div>(法人名、所在地及び代表者)岩崎通信機株式会社</div>
              <div>東京都杉並区久我山1丁目7番41号</div>
              <div>代表取締役社長 木村彰吾</div>
              <div>(責任者)個人情報保護管理者</div>
              <h5 class="mt-4">[６] 個人情報の取扱いの委託について</h5>
              <div>個人情報の取扱いを利用目的の範囲内で委託する場合があります。</div>
              <h5 class="mt-4">[７] 保有個人データの開示等について</h5>
              <div>ご本人からの求めにより、当社の保有個人データの利用目的の通知・内容の開示・訂正・追加又は削除・利用の停止・消去及び第三者への提供の停止（「開示等」といいます。）に応じます。</div>
              <div>詳細については、当社の「個人情報の取扱い（https://www.iwatsu.co.jp/manage/）」をご覧ください。</div>
              <h5 class="mt-4">[８] 任意性について</h5>
              <div>個人情報の提供は任意です。ただし、必須項目に入力漏れがある場合、または正しい情報が入力されない場合には、ご要望に沿えないことがあります。</div>
              <h5 class="mt-4">[９] 個人情報を入力するにあたっての注意事項</h5>
              <div>ご入力いただいた電話番号、またはメールアドレスに、お電話、またはメールを差し上げることがあります。</div>
              <h5 class="mt-4">[１０] 本人が容易に認識できない方法による個人情報の取得</h5>
              <div>より良いお客さまサービスを提供していくための閲覧状況の分析として、クッキー(Cookie)やウェブビーコン(Web beacon)を利用していますが、特定の個人を識別したり、個人情報を収集することはありません。</div>
              <h5 class="mt-4">[１１] 個人情報の安全管理措置について</h5>
              <div>取得した個人情報については、漏洩、滅失または棄損の防止と是正、その他個人情報の安全管理のために必要かつ適切な措置を講じます。</div>
              <div>このサイトは、SSL(Secure Socket Layer)による暗号化措置を講じています。</div>
              <h5 class="mt-4">[１２] 個人情報保護方針</h5>
              <div>当社ウェブサイトの「個人情報保護方針（https://www.iwatsu.co.jp/security/）」をご覧下さい。</div>
              <div class="mt-4">【お問合せ先】</div>
              <div>〒168-8501 東京都杉並区久我山1-7-41</div>
              <div>岩崎通信機株式会社 『個人情報相談窓口（コーポレート・マネジメント本部経営管理部）』</div>
              <div>TEL 03-5370-5111(祝祭日及び当社の休業日を除く9:00～17:30)</div>
            </div>
          </div>
        </div>
      </div>
      <template slot="footer">
        <proa-button
          :disabled="!readTerms"
          @click.native="toggleConfirmTermsModal(false)"
        >
          個人情報の取扱について確認した
        </proa-button>
      </template>
    </proa-modal>
  </div>
</template>

<script>

export default {
  name: 'ConfirmTermsCheckBox',
  props: {
    agreedTerms: Boolean
  },
  data() {
    return {
      confirmeTermsModal: false,
      readTerms: false
    }
  },
  methods: {
    onChange: function() {
      this.$emit('onChange')
      this.$nextTick(() => {
        if (!this.agreedTerms) {
          this.readTerms = false
        }
      })
    },
    onClickWrapper: function() {
      if (this.readTerms) {
        this.$refs.input.click()
      } else {
        this.toggleConfirmTermsModal(true)
      }
    },
    // NOTE: -80は上下の40pxのpadding分
    onScrollTermsWrapper: function() {
      if (this.readTerms ) return
      if (this.$refs.termsContens.offsetHeight - (this.$refs.termsContentsWrapper.offsetHeight + this.$refs.termsContentsWrapper.scrollTop - 80) <= 10) {
        this.readTerms = true
      }
    },
    toggleConfirmTermsModal: function(toggle, resetRead) {
      if (resetRead) {
        this.readTerms = false
      }
      this.confirmeTermsModal = toggle
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.checkbox-wrapper {
  cursor: pointer;
}

input[type="checkbox"] {
  display: none;
}

.checkbox {
  box-sizing: border-box;
  display: inline-block;
  padding: 5px 17px;
  position: relative;
  width: auto;
}
.checkbox::before {
  content: '';
  display: block;
  height: 16px;
  left: 5px;
  margin-top: -8px;
  position: absolute;
  top: 50%;
  width: 16px;
  border: 2px solid $dark-border-color;
  border-radius: 50%;
  background-color: white;
}
.checkbox::after {
  content: '';
  border-right: 2.5px solid white;
  border-bottom: 2.5px solid white;
  display: block;
  height: 10px;
  width: 6px;
  left: 10px;
  margin-top: -6px;
  opacity: 0;
  position: absolute;
  top: 50%;
  transform: rotate(45deg);
}

input[type=checkbox]:checked + .checkbox::before {
  border: none;
  background-color: $secondary-color;
}

input[type=checkbox]:checked + .checkbox::after {
  opacity: 1;
}

.terms-flex-wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100% - 20px);
}

.contents-wrapper {
  text-align: left;
  margin-top: 20px;
  padding: 40px;
  box-shadow: 0px 0px 4px #00000026;
  border-radius: 4px;
  overflow: auto;
}
</style>
